// extracted by mini-css-extract-plugin
export default {"DownloadPDF":"_DownloadPDF--CiXD3","TooltipMessage":"_TooltipMessage--mLOwc"};